export function formatMontant(montant: number): string {
	return montant.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}